import React from 'react';
import LegalPageLayout from './LegalPageLayout';
import { privacyPolicy } from './legalContent';

const PrivacyPolicy = () => {
  return <LegalPageLayout document={privacyPolicy} />;
};

export default PrivacyPolicy;
